import { TextSkeleton } from "@/components/Skeletons";

const HOUSEHOLD_PROPERTIES = 2;
const CONTACT_PROPERTIES = 4;

export const ContactSkeleton = () => {
  return (
    <>
      <TextSkeleton className="h-6 w-1/4" />
      <div className="flex flex-wrap justify-between gap-6 rounded-md bg-white p-6 shadow-light">
        {Array(CONTACT_PROPERTIES)
          .fill(0)
          .map((_, i) => (
            <div className="flex w-[calc(50%-1.5rem)] flex-col gap-2" key={i}>
              <TextSkeleton className="h-6 w-1/2" />
              <TextSkeleton className="h-6 w-1/2" />
            </div>
          ))}
      </div>
    </>
  );
};

export const HouseholdSkeleton = () => {
  return (
    <>
      <TextSkeleton className="h-6 w-1/4" />
      <div className="flex flex-wrap justify-between gap-6 rounded-md bg-white p-6 shadow-light">
        {Array(HOUSEHOLD_PROPERTIES)
          .fill(0)
          .map((_, i) => (
            <div className="flex w-[calc(50%-1.5rem)] flex-col gap-2" key={i}>
              <TextSkeleton className="h-6 w-1/2" />
              <TextSkeleton className="h-6 w-1/2" />
            </div>
          ))}
      </div>
    </>
  );
};
